(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page-accordion"]) return;
  try {
    
  var interval = setInterval(function(){
    if ($) {
      clearInterval(interval);
      
      $(document).ready(function(){

        $('.page-accordion .PageContent').append('<div class="accordion"></div>');

        $('.page-accordion .PageContent > *:not(.accordion)').each(function(){
          if ($(this).is('h2')) {
            $(this).addClass('accordion-title');
            $('.page-accordion .PageContent .accordion').append('<div class="accordion-item"></div>');
            $('.page-accordion .PageContent .accordion .accordion-item:last').append($(this)).append('<div class="accordion-content"></div>');
          } else {
            $('.page-accordion .PageContent .accordion .accordion-item:last .accordion-content').append($(this));
          }
        });

        $('.accordion').each(function(i){
          var accordion = $(this);
          var toggleSpeed = accordion.attr('data-speed') || 100;
        
          function open(item, speed) {
            accordion.find('.accordion-item').not(item).removeClass('active').find('.accordion-content').slideUp(speed);
            item.addClass('active').find('.accordion-content').slideDown(speed);
          }
          function close(item, speed) {
            item.removeClass('active').find('.accordion-content').slideUp(speed);
          }
        
          open(accordion.find('.active:first'), 0);
        
          accordion.on('click', '.accordion-title', function(e) {
            e.preventDefault();
            if ($(this).closest('.accordion-item').is('.active')) close($(this).closest('.accordion-item'), toggleSpeed);
            else open($(this).closest('.accordion-item'), toggleSpeed);
          });
        });

        // N2
        $('.page-accordion .PageContent .accordion-item').each(function(){
          $(this).find('.accordion-content').append('<div class="accordion-n2"></div>');

          $(this).find('.accordion-content > *:not(.accordion-n2)').each(function(){
            if ($(this).is('h3')) {
              $(this).addClass('accordion-title-n2');
              $(this).closest('.accordion-content').find('.accordion-n2').append('<div class="accordion-item-n2"></div>');
              $(this).closest('.accordion-content').find('.accordion-n2 .accordion-item-n2:last').append($(this)).append('<div class="accordion-content-n2"></div>');
            } else {
              $(this).closest('.accordion-content').find('.accordion-n2 .accordion-item-n2:last .accordion-content-n2').append($(this));
            }
          });
        });

        $('.accordion-n2').each(function(i){
          var accordion = $(this);
          var toggleSpeed = accordion.attr('data-speed') || 100;
        
          function open(item, speed) {
            accordion.find('.accordion-item-n2').not(item).removeClass('active').find('.accordion-content-n2').slideUp(speed);
            item.addClass('active').find('.accordion-content-n2').slideDown(speed);
          }
          function close(item, speed) {
            item.removeClass('active').find('.accordion-content-n2').slideUp(speed);
          }
        
          open(accordion.find('.active:first'), 0);
        
          accordion.on('click', '.accordion-title-n2', function(e) {
            e.preventDefault();
            if ($(this).closest('.accordion-item-n2').is('.active')) close($(this).closest('.accordion-item-n2'), toggleSpeed);
            else open($(this).closest('.accordion-item-n2'), toggleSpeed);
          });
        });
      });
    }
  }, 100);

  } catch(e) { console.error(e); }
})();
})();
